import { render } from "./transactionStatus.vue?vue&type=template&id=32ce1390"
import script from "./transactionStatus.vue?vue&type=script&lang=js"
export * from "./transactionStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__